import { OrderMarker } from '@/Enums';
import { useOrderMarkerOptions } from '@/Enums/OrderMarkerHooks';
import { useSelectedOrdersRows } from '@/Hooks';

export const useChangeOtherStatusesOptions = () => {
  const { orderIds, isSalesPage, orderType } = useSelectedOrdersRows();

  const { options } = useOrderMarkerOptions(orderType, [
    OrderMarker.Paid,
    OrderMarker.NotPaid,
    OrderMarker.Shipped,
    OrderMarker.NotShipped,
  ]);

  return {
    isSalesPage,
    selectedOrders: orderIds,
    options,
  };
};
